<template>
  <tbody>
  <tr v-for="n in rows" :key="n">
    <td v-for="col in columns" :key="col">
      <div class="skeleton"></div>
    </td>
  </tr>
  </tbody>
</template>

<script>
export default {
  name: "LoadingSkeleton",
  props: {
    rows: {
      type: Number,
      default: 10,
    },
    columns: {
      type: Number,
      default: 6,
    },
  },
};
</script>

<style scoped>
.skeleton {
  height: 1.8rem;
  width: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/shared/LoadingSkeleton.vue